import { redirect } from '@tanstack/react-router'

/**
 * Garde-fous d'accès par rôle, pour les `beforeLoad` des routes.
 *
 * Demande du client (21/10) : retirer l'agenda au médecin B-SohTak. Cacher le
 * lien du menu ne suffisait pas : l'URL restait ouverte. Et les pages
 * d'administration étaient, elles aussi, accessibles par URL à tout médecin.
 *
 * Le rôle vient du contexte posé par la route `_authenticated` (session ou
 * cache par onglet) : aucun aller-retour réseau de plus.
 *
 * Usage : `beforeLoad: requireAdmin` ou `beforeLoad: redirectBsohtakDoctor('/my-missions')`.
 */
type GuardArgs = { context: unknown }

const roleOf = (args: GuardArgs): string | undefined =>
  (args.context as { user?: { user_role?: string } }).user?.user_role

/** Réservé aux administrateurs : tout autre rôle revient au tableau de bord. */
export const requireAdmin = (args: GuardArgs) => {
  if (roleOf(args) !== 'admin') throw redirect({ to: '/' })
}

/** Réservé aux médecins B-SohTak (« Ma disponibilité »). */
export const requireBsohtakDoctor = (args: GuardArgs) => {
  if (roleOf(args) !== 'bsohtak_doctor') throw redirect({ to: '/' })
}

/**
 * Pages de l'agenda (rendez-vous, cliniques, horaires) : sans objet pour un
 * médecin B-SohTak, qui reçoit des dossiers et non des consultations.
 */
export const redirectBsohtakDoctor =
  (to: '/my-missions' | '/') => (args: GuardArgs) => {
    if (roleOf(args) === 'bsohtak_doctor') throw redirect({ to })
  }
